/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Outstanding_InvoicesInputs */

const en_admin_membership_confirmations_outstanding_invoices = /** @type {(inputs: Admin_Membership_Confirmations_Outstanding_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have several outstanding invoices. Adding members is disabled until all invoices are paid.`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Outstanding_InvoicesInputs) => LocalizedString} */
const de_admin_membership_confirmations_outstanding_invoices = en_admin_membership_confirmations_outstanding_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_Outstanding_InvoicesInputs) => LocalizedString} */
const es_admin_membership_confirmations_outstanding_invoices = en_admin_membership_confirmations_outstanding_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_Outstanding_InvoicesInputs) => LocalizedString} */
const fr_admin_membership_confirmations_outstanding_invoices = en_admin_membership_confirmations_outstanding_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_Outstanding_InvoicesInputs) => LocalizedString} */
const it_admin_membership_confirmations_outstanding_invoices = en_admin_membership_confirmations_outstanding_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_Outstanding_InvoicesInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_outstanding_invoices = en_admin_membership_confirmations_outstanding_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_Outstanding_InvoicesInputs) => LocalizedString} */
const pl_admin_membership_confirmations_outstanding_invoices = en_admin_membership_confirmations_outstanding_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_Outstanding_InvoicesInputs) => LocalizedString} */
const hu_admin_membership_confirmations_outstanding_invoices = en_admin_membership_confirmations_outstanding_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_Outstanding_InvoicesInputs) => LocalizedString} */
const ro_admin_membership_confirmations_outstanding_invoices = en_admin_membership_confirmations_outstanding_invoices;

/**
* | output |
* | --- |
* | "You have several outstanding invoices. Adding members is disabled until all invoices are paid." |
*
* @param {Admin_Membership_Confirmations_Outstanding_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_outstanding_invoices = /** @type {((inputs?: Admin_Membership_Confirmations_Outstanding_InvoicesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Outstanding_InvoicesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_outstanding_invoices(inputs)
	if (locale === "de") return de_admin_membership_confirmations_outstanding_invoices(inputs)
	if (locale === "es") return es_admin_membership_confirmations_outstanding_invoices(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_outstanding_invoices(inputs)
	if (locale === "it") return it_admin_membership_confirmations_outstanding_invoices(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_outstanding_invoices(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_outstanding_invoices(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_outstanding_invoices(inputs)
	return ro_admin_membership_confirmations_outstanding_invoices(inputs)
});
export { admin_membership_confirmations_outstanding_invoices as "admin.membership_confirmations.outstanding_invoices" }